<div class="k-loading-panel" *ngIf="loaderService.active || loaderService?.activeOther">
  <div class="k-loading-panel-mask"></div>
  <div class="k-loading-panel-wrapper">
    <kendo-loader type="infinite-spinner" themeColor="primary" size="large" *ngIf="!isMobile">
    </kendo-loader>
    <div class="mobile-loader" *ngIf="isMobile"></div>
    <div class="k-loading-panel-text" *ngIf="loaderService?.displayText">{{loaderService?.displayText}}</div>
    <div class="k-loading-panel-sub-text" *ngIf="loaderService?.displaySubText">{{loaderService?.displaySubText}}</div>
  </div>
</div>